export default __webpack_public_path__ + "static/media/Reactssr1.73641125.webp";